import * as React from "react";
import {OrderedMap} from "immutable";
import ReduxInfiniteScroll from "redux-infinite-scroll";
import Meta from "../../_data/models/Meta";
import {ResourceType} from "../../_helpers/data";
import Style from "../../_data/models/Style";
import MyStylesGalleryImageComponent from "../../style/components/MyStylesGalleryImageComponent";
import LoadingIndicatorComponent from "../../_widgets/loadingIndicator/LoadingIndicatorComponent";

interface result {
    items:any;
    meta:Meta;
}

interface Props {
    styles: result;
    loadMore: (meta: Meta, resource: string, isLiked?: boolean) => void;
    loadingTab: boolean;
    likedStyleLoad: boolean;
}

const MyProfileStylesComponent = ({styles, loadMore, loadingTab, likedStyleLoad}: Props) => {
    if (styles.items.toArray().length == 0 && !loadingTab) {
        return (
            <div className="tabs-content" data-tabs-content="users">
                <div className="tabs-panel is-active">
                    No Images
                </div>
            </div>
        )
    }
    else {
        return (
            <div className="featured-image-block-grid">
                <ReduxInfiniteScroll
                    loadMore={() => loadMore(styles.meta, ResourceType.style, likedStyleLoad)}
                    loadingMore={loadingTab}
                    showLoader={true}
                    loader={<LoadingIndicatorComponent/>}
                    elementIsScrollable={false}
                    holderType="div"
                    className="row large-up-3 small-up-1"
                    threshold={100}>
                    {
                        styles.items.toArray().map(style => {
                            return (
                                <MyStylesGalleryImageComponent key={style.id} item={style}/>
                            )
                        })
                    }
                </ReduxInfiniteScroll>
            </div>
        );
    }
};

export default MyProfileStylesComponent;


// WEBPACK FOOTER //
// ./app/client/user/components/MyProfileStylesComponent.tsx